/**
 * Wrapper button for the design library button to pass our router specific link
 */

import { type ExoticComponent, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { type ButtonProps, Button as DesignLibraryButton } from '@mweb/zappos-ui/Button';

type ButtonWrapperProps = Omit<ButtonProps, 'linkComponent' | 'linkProps'>;

const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonWrapperProps>(({ href, ...rest }, ref) => (
  <DesignLibraryButton {...rest} href={href} linkComponent={Link as ExoticComponent} linkProps={{ to: href }} ref={ref} />
));

Button.displayName = 'Button';

export default Button;
